export const MEASUREMENT_ID='G-B32TXVZ9E5';
export const CONSENT_KEY='sayyadi.analytics-consent.v1';
const ORIGIN='https://sayyadi.com.tr';
export function publicPage(value){
 try{const u=new URL(value,ORIGIN);return u.protocol==='https:'&&['sayyadi.com.tr','www.sayyadi.com.tr'].includes(u.hostname)&&!u.port&&!u.username&&!u.password&&!u.search&&!u.hash&&u.pathname==='/'?ORIGIN+'/':null;}catch{return null;}
}
export function createPublicAnalytics(win,doc){
 let consent=null,visitor=false,loaded=Boolean(doc.getElementById('sayyadi-public-analytics')),stopped=false,last=null;
 const disable='ga-disable-'+MEASUREMENT_ID;
 const read=()=>{try{const v=win.localStorage.getItem(CONSENT_KEY);return ['granted','denied'].includes(v)?v:null;}catch{return null;}};
 consent=read();win[disable]=true;
 function command(){win.dataLayer.push(arguments);}
 function refresh(){
  const safe=publicPage(win.location.href);
  win[disable]=stopped||!visitor||consent!=='granted'||!safe;
  if(win[disable]){last=null;return;}
  if(!loaded){
   loaded=true;win.dataLayer=win.dataLayer||[];
   command('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
   command('consent','update',{analytics_storage:'granted'});
   command('js',new Date());
   command('config',MEASUREMENT_ID,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,
    page_location:safe,page_referrer:'',page_title:'Sayyâdi'});
   const script=doc.createElement('script');script.id='sayyadi-public-analytics';script.async=true;
   script.src='https://www.googletagmanager.com/gtag/js?id='+MEASUREMENT_ID;doc.head.appendChild(script);
  }
  if(last!==safe){command('event','page_view',{send_to:MEASUREMENT_ID,page_location:safe,page_referrer:'',page_title:'Sayyâdi'});last=safe;}
 }
 function clearCookies(){for(const c of doc.cookie.split(';')){const name=c.trim().split('=')[0];if(/^_ga(?:_|$)/.test(name))for(const domain of ['', ';domain=sayyadi.com.tr',';domain=.sayyadi.com.tr',';domain=www.sayyadi.com.tr'])doc.cookie=name+'=;Max-Age=0;path=/'+domain+';SameSite=Lax;Secure';}}
 const originals={},wrapped={};
 for(const name of ['pushState','replaceState']){
  originals[name]=win.history[name];wrapped[name]=function(...args){win[disable]=true;const result=originals[name].apply(this,args);refresh();return result;};win.history[name]=wrapped[name];
 }
 const onPop=()=>refresh();
 const onStorage=e=>{if(e.key!==null&&e.key!==CONSENT_KEY)return;consent=read();if(consent!=='granted'){win[disable]=true;clearCookies();}else if(loaded)command('consent','update',{analytics_storage:'granted'});refresh();};
 win.addEventListener('popstate',onPop);win.addEventListener('storage',onStorage);
 return {
  getConsent:()=>consent,
  setVisitor(value){visitor=value===true;refresh();},
  choose(value){
   if(!['granted','denied'].includes(value))throw Error('Geçersiz analitik tercihi.');
   consent=value;try{win.localStorage.setItem(CONSENT_KEY,value);}catch{}
   if(value==='denied'){win[disable]=true;last=null;clearCookies();if(loaded)command('consent','update',{analytics_storage:'denied'});}
   else{if(loaded)command('consent','update',{analytics_storage:'granted'});refresh();}
  },
  stop(){stopped=true;win[disable]=true;win.removeEventListener('popstate',onPop);win.removeEventListener('storage',onStorage);for(const name of Object.keys(originals))if(win.history[name]===wrapped[name])win.history[name]=originals[name];},
 };
}
